// Ordem de exibição pras formas mais comuns — qualquer outra categoria que
// aparecer no histórico (Cheque, Boleto, Crediário...) entra depois dessas,
// em ordem alfabética, e 'Outros' sempre por último. As categorias em si vêm
// prontas do backend (resultado.porFormaPagamento, ver GetAll.ts e
// CategoriaPagamento.ts) — essa função só cuida da ordem de exibição.
const ORDEM_CATEGORIAS_CONHECIDAS = ['Dinheiro', 'PIX', 'Cartão', 'Cheque'];

export function ordenarCategoriasPagamento(categorias: string[]): string[] {
  return [...categorias].sort((a, b) => {
    if (a === 'Outros') return 1;
    if (b === 'Outros') return -1;
    const indiceA = ORDEM_CATEGORIAS_CONHECIDAS.indexOf(a);
    const indiceB = ORDEM_CATEGORIAS_CONHECIDAS.indexOf(b);
    if (indiceA === -1 && indiceB === -1) return a.localeCompare(b, 'pt-BR');
    if (indiceA === -1) return 1;
    if (indiceB === -1) return -1;
    return indiceA - indiceB;
  });
}
